import { IBudgetConstruction } from '@apply/api/src/api/ApplyApi';
import { MoneyBox } from '@apply/components';
import { formatCurrencyOrUndefined } from '@apply/ui';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetConstructionField } from '../../../../../queries/useBudgetConstructionField';

interface InspectionsProps {
    propertyGuid: string;
    required?: boolean;
    isReview?: boolean;
}

export const Inspections: React.FC<InspectionsProps> = ({ required = false, propertyGuid, isReview = false }) => {
    const [inspections, set_inspections] = useBudgetConstructionField<number>(
        propertyGuid,
        (b) => b.values?.['Site Work']?.['Inspections'] ?? 0,
        (b, v) => ({ ...b, values: { ...b.values, 'Site Work': { ...b.values?.['Site Work'], 'Inspections': v } } })
    );
    const label = 'Inspections';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={formatCurrencyOrUndefined(inspections)}
                />
            ) : (
                <MoneyBox
                    id={'inspections'}
                    allowNegative={false}
                    value={inspections}
                    onChange={(value) => set_inspections(value)}
                    required={required}
                    label={label}
                />
            )}
        </>
    );
};
